export enum SignupTarget {
    INSTAGRAM = 'instagram',
    MESSENGER = 'messenger',
    WHATSAPP = 'whatsapp',
}
